var exports = {
  "D": "x936d19a0--a214f5--title",
};

module.exports = exports;
